import React from 'react'
import './insight-hero-style.scss';
function InsightHero(props) {
  return (
    <div className='insight-hero'>
      <h1 className='display-1'>{props.title}</h1>
    </div>
  )
}
InsightHero.Article = (props) => {
  return (
    <div className='insight-hero'>
      <h1 className='display-1'>{props.title}</h1>
    </div>
  )
}
InsightHero.ArticleWithBanner = (props) => {
  return (
    <div className='insight-hero'>
      <h1 className='display-1'>{props.title}</h1>
      <div className="hero-banner"></div>
    </div>
  )
}
export default InsightHero